import type { ServiceCode } from '@common/enums';
import { fetchJson } from '@frontend/store/fetch';
import { getUrlQueryParameters } from './queryParameterUtils';

export async function isServiceProviderForServiceAndSetting(
    query: {
        employmentId: string;
        isActive: boolean;
        isBiometrist?: boolean;
        isRequestCreator?: boolean;
        serviceCode?: ServiceCode;
    },
    signal: AbortSignal
) {
    const url = getUrlQueryParameters(`/api/serviceProviders`, query);
    const serviceProviders = await fetchJson<{ total: number }>({
        method: 'GET',
        signal,
        url: url,
    });

    return (serviceProviders.json?.total ?? 0) > 0;
}
